import { render, staticRenderFns } from "./EstadisticasCarga.vue?vue&type=template&id=1d2659c5&scoped=true"
import script from "./EstadisticasCarga.vue?vue&type=script&lang=js"
export * from "./EstadisticasCarga.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasCarga.vue?vue&type=style&index=0&id=1d2659c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2659c5",
  null
  
)

export default component.exports